module.exports = __webpack_public_path__ + "img/donante-intercontinental.9e5b6f62.jpeg";